import * as React from 'react'
import { TitleWatcherConnected } from './TitleWatcherConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TitleWatcherExamples = () => {
  return (
    <div className="TitleWatcherExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TitleWatcherConnected />
      </Provider>
    </div>
  )
}
